import { useNavigate } from 'react-router-dom';
import { Trash2, ShoppingBag, ArrowRight, Plus, Minus } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function Cart() {
  const { items, removeItem, updateQty, total, clearCart } = useCart();
  const navigate = useNavigate();
  const shipping = total > 500 ? 0 : 15;
  const tax = parseFloat((total * 0.19).toFixed(2));
  const grandTotal = total + shipping + tax;

  if (items.length === 0) return (
    <div style={{ textAlign: 'center', padding: '100px 24px' }}>
      <ShoppingBag size={64} color="var(--text-muted)" style={{ marginBottom: 24 }} />
      <h2 style={{ fontFamily: 'Syne', fontSize: 28, marginBottom: 12 }}>Your cart is empty</h2>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 32 }}>Add some amazing products to get started</p>
      <button className="btn btn-primary btn-lg" onClick={() => navigate('/products')}>Continue Shopping</button>
    </div>
  );

  return (
    <div className="container" style={{ padding: '40px 24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
        <h1 style={{ fontFamily: 'Syne', fontSize: 36, fontWeight: 800 }}>Shopping Cart</h1>
        <button onClick={clearCart} className="btn btn-secondary btn-sm" style={{ color: 'var(--danger)' }}>Clear Cart</button>
      </div>
      <div className="cart-layout" style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 32 }}>
        <div>
          {items.map(item => (
            <div key={item._id} className="cart-item" style={{ display: 'flex', gap: 20, padding: 20, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, marginBottom: 12, alignItems: 'center' }}>
              <img src={item.thumbnail || 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=200'} alt={item.name} style={{ width: 90, height: 90, objectFit: 'cover', borderRadius: 12, background: 'var(--bg-secondary)' }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>{item.brand}</div>
                <h4 style={{ fontFamily: 'Syne', fontWeight: 700, marginBottom: 4 }}>{item.name}</h4>
                <div style={{ color: 'var(--gold)', fontWeight: 700, fontSize: 18 }}>${item.price.toLocaleString()}</div>
              </div>
              <div className="cart-item-controls" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', background: 'var(--bg-secondary)', borderRadius: 10, border: '1px solid var(--border)', overflow: 'hidden' }}>
                  <button onClick={() => updateQty(item._id, item.quantity - 1)} style={{ padding: '8px 14px', background: 'none', border: 'none', color: 'var(--text-primary)', cursor: 'pointer' }}><Minus size={14} /></button>
                  <span style={{ padding: '8px 12px', fontWeight: 600, minWidth: 40, textAlign: 'center' }}>{item.quantity}</span>
                  <button onClick={() => updateQty(item._id, item.quantity + 1)} style={{ padding: '8px 14px', background: 'none', border: 'none', color: 'var(--text-primary)', cursor: 'pointer', opacity: item.quantity >= item.stock ? 0.4 : 1 }} disabled={item.quantity >= item.stock}><Plus size={14} /></button>
                </div>
                <div style={{ fontWeight: 700, fontSize: 18, minWidth: 80, textAlign: 'right' }}>${(item.price * item.quantity).toLocaleString()}</div>
                <button onClick={() => removeItem(item._id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--danger)', padding: 8 }}><Trash2 size={18} /></button>
              </div>
            </div>
          ))}
        </div>
        <div>
          <div className="card cart-summary-sticky" style={{ position: 'sticky', top: 90 }}>
            <h3 style={{ fontFamily: 'Syne', fontSize: 20, fontWeight: 700, marginBottom: 24 }}>Order Summary</h3>
            {[['Subtotal', `$${total.toLocaleString()}`], ['Shipping', shipping === 0 ? 'FREE' : `$${shipping}`], ['Tax (19%)', `$${tax}`]].map(([label, val]) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14, color: 'var(--text-secondary)', fontSize: 15 }}>
                <span>{label}</span><span style={{ color: val === 'FREE' ? 'var(--success)' : 'var(--text-primary)', fontWeight: val === 'FREE' ? 600 : 400 }}>{val}</span>
              </div>
            ))}
            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, marginTop: 8, display: 'flex', justifyContent: 'space-between', fontFamily: 'Syne', fontWeight: 800, fontSize: 22 }}>
              <span>Total</span><span style={{ color: 'var(--gold)' }}>${grandTotal.toFixed(2)}</span>
            </div>
            {total <= 500 && <div style={{ marginTop: 12, padding: '10px 14px', background: 'rgba(99,102,241,0.1)', borderRadius: 10, fontSize: 13, color: 'var(--accent)' }}>Add ${(500 - total).toFixed(0)} more for free shipping</div>}
            <button className="btn btn-primary btn-full btn-lg" style={{ marginTop: 24 }} onClick={() => navigate('/checkout')}>
              Proceed to Checkout <ArrowRight size={18} />
            </button>
            <button className="btn btn-secondary btn-full" style={{ marginTop: 10 }} onClick={() => navigate('/products')}>Continue Shopping</button>
          </div>
        </div>
      </div>
    </div>
  );
}
